/*
 * Black Week - nieskończone przewijanie kart wariantów + odliczanie.
 *
 * Pierwsze karty renderuje Liquid. Reszta wariantów czeka w kolejce
 * (<script data-bw-reszta> z adresami /products/<uchwyt>?variant=<id>).
 * Przy zbliżeniu do końca listy bierzemy kolejną paczkę i każdą kartę
 * dociągamy przez Section Rendering API na adresie produktu
 * (&section_id=black-week-karta). Karty doklejamy w kolejności z listy;
 * pusta odpowiedź = wariant bez promocji, pomijamy go.
 */
(function () {
  function przewijanie(sekcja) {
    var lista = sekcja.querySelector('[data-bw-lista]');
    var dalej = sekcja.querySelector('[data-bw-dalej]');
    var zrodlo = sekcja.querySelector('[data-bw-reszta]');
    if (!lista || !dalej || !zrodlo || sekcja.dataset.bwGotowe) return;
    sekcja.dataset.bwGotowe = '1';

    var kolejka = [];
    try { kolejka = JSON.parse(zrodlo.textContent) || []; } catch (e) { kolejka = []; }
    var naRaz = parseInt(sekcja.dataset.naRaz, 10) || 8;
    var koniec = sekcja.querySelector('[data-bw-koniec]');
    var pusto = sekcja.querySelector('[data-bw-pusto]');
    var wiecej = sekcja.querySelector('[data-bw-wiecej]');
    var laduje = false;
    var blad = false;
    var obserwator;

    function zakoncz() {
      if (obserwator) obserwator.disconnect();
      dalej.remove();
      var sa = lista.children.length > 0;
      if (koniec) koniec.hidden = !sa;
      if (pusto) pusto.hidden = sa;
    }

    function karta(sciezka) {
      var url = new URL(sciezka, window.location.origin);
      url.searchParams.set('section_id', 'black-week-karta');
      return fetch(url.toString(), { credentials: 'same-origin' })
        .then(function (odp) {
          if (odp.status === 404) return null; /* produkt usunięty/ukryty */
          if (!odp.ok) throw new Error('HTTP ' + odp.status);
          return odp.text();
        })
        .then(function (html) {
          if (!html) return null;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return doc.querySelector('[data-bw-lista] > li');
        });
    }

    function doladuj() {
      if (laduje) return;
      if (!kolejka.length) return zakoncz();
      laduje = true;
      blad = false;
      dalej.classList.add('jest-ladowanie');
      var paczka = kolejka.slice(0, naRaz);

      Promise.all(paczka.map(karta))
        .then(function (karty) {
          kolejka = kolejka.slice(paczka.length);
          var fragment = document.createDocumentFragment();
          karty.forEach(function (li) {
            if (!li) return;
            li.classList.add('black-week__wjazd');
            fragment.appendChild(document.importNode(li, true));
          });
          lista.appendChild(fragment);
          if (!kolejka.length) zakoncz();
        })
        .catch(function () {
          /* Błąd sieci: paczka zostaje w kolejce, przycisk spróbuje ponownie. */
          blad = true;
        })
        .finally(function () {
          laduje = false;
          dalej.classList.remove('jest-ladowanie');
          /* Paczka nie wypełniła ekranu - obserwator sam się drugi raz nie zgłosi. */
          if (!blad && kolejka.length && dalej.isConnected) {
            var r = dalej.getBoundingClientRect();
            if (r.top < window.innerHeight + 800) doladuj();
          }
        });
    }

    if (wiecej) wiecej.addEventListener('click', doladuj);

    if ('IntersectionObserver' in window) {
      obserwator = new IntersectionObserver(
        function (wpisy) {
          if (wpisy.some(function (w) { return w.isIntersecting; })) doladuj();
        },
        { rootMargin: '0px 0px 800px 0px' }
      );
      obserwator.observe(dalej);
    }
  }

  function licznik(sekcja) {
    var el = sekcja.querySelector('[data-bw-licznik]');
    if (!el || el.dataset.bwGotowe) return;
    el.dataset.bwGotowe = '1';

    /* „2026-11-30 23:59" w czasie polskim. Strefę liczymy przez Intl,
       żeby wynik nie zależał od zegara strefowego klienta (np. turysta w UK). */
    var m = (el.dataset.koniec || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?$/);
    if (!m) return;
    /* Czas polski z chwili UTC (ms) - części daty jak na zegarku w Warszawie. */
    function wWarszawie(ms) {
      var p = {};
      try {
        new Intl.DateTimeFormat('en-US', {
          timeZone: 'Europe/Warsaw', hourCycle: 'h23',
          year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'
        }).formatToParts(new Date(ms)).forEach(function (c) { p[c.type] = +c.value; });
      } catch (e) {
        var x = new Date(ms + 3600000);
        p = { year: x.getUTCFullYear(), month: x.getUTCMonth() + 1, day: x.getUTCDate(), hour: x.getUTCHours(), minute: x.getUTCMinutes(), second: x.getUTCSeconds() };
      }
      return p;
    }
    /* Godzina na zegarku w Warszawie → chwila UTC (ms). Date.UTC sam przenosi
       nadmiarowe dni na kolejny miesiąc. */
    function zWarszawy(y, mo, d, h, mi, s) {
      var jakoUtc = Date.UTC(y, mo, d, h, mi, s);
      var p = wWarszawie(jakoUtc);
      return jakoUtc - (Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second) - jakoUtc);
    }

    var koniecAkcji = zWarszawy(+m[1], +m[2] - 1, +m[3], m[4] ? +m[4] : 23, m[5] ? +m[5] : 59, 59);
    var dzienZmiany = el.dataset.dzienZmiany === '' || el.dataset.dzienZmiany == null ? -1 : +el.dataset.dzienZmiany;
    var etykieta = el.querySelector('[data-bw-etykieta]');

    /* Licznik liczy do najbliższego startu nowych promocji (dzień tygodnia
       o 00:00 czasu polskiego), a w ostatnim tygodniu do końca całej akcji. */
    function cel() {
      if (dzienZmiany < 0) return { ms: koniecAkcji, ostatni: true };
      var p = wWarszawie(Date.now());
      var dzis = new Date(Date.UTC(p.year, p.month - 1, p.day)).getUTCDay();
      var dni = (dzienZmiany - dzis + 7) % 7 || 7;
      var zmiana = zWarszawy(p.year, p.month - 1, p.day + dni, 0, 0, 0);
      return zmiana >= koniecAkcji ? { ms: koniecAkcji, ostatni: true } : { ms: zmiana, ostatni: false };
    }

    var pola = {
      d: el.querySelector('[data-bw-d]'), h: el.querySelector('[data-bw-h]'),
      m: el.querySelector('[data-bw-m]'), s: el.querySelector('[data-bw-s]')
    };
    function dwa(n) { return (n < 10 ? '0' : '') + n; }
    var timer;
    function tik() {
      var c = cel();
      var zostalo = Math.floor((c.ms - Date.now()) / 1000);
      if (etykieta) {
        var tekst = c.ostatni ? el.dataset.etykietaKoniec : el.dataset.etykietaTydzien;
        if (tekst && etykieta.textContent !== tekst) etykieta.textContent = tekst;
      }
      if (zostalo <= 0 && c.ostatni) {
        clearInterval(timer);
        var po = el.dataset.poKoncu;
        if (po) {
          el.textContent = po;
          el.classList.add('jest-po');
          el.hidden = false;
        } else {
          el.hidden = true;
        }
        return false;
      }
      pola.d.textContent = Math.floor(zostalo / 86400);
      pola.h.textContent = dwa(Math.floor(zostalo % 86400 / 3600));
      pola.m.textContent = dwa(Math.floor(zostalo % 3600 / 60));
      pola.s.textContent = dwa(zostalo % 60);
      el.hidden = false;
      return true;
    }
    if (tik()) timer = setInterval(tik, 1000);
  }

  function start() {
    document.querySelectorAll('[data-black-week]').forEach(function (s) {
      przewijanie(s);
      licznik(s);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
